export { default } from "./Fade.mjs";